import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

import SweetAlert from 'react-bootstrap-sweetalert';

class DeleteButton extends Component {
    constructor(props) {
        super(props);

        var optionsDefault = {
            openConfirm: false,
            title: '¿Estás Seguro?',
            message: 'No podrás desaser está opción!',
            buttonConfirm: 'Si, borrar!',
            buttonCancel: 'Cancelar'
        };

        var options = { ...optionsDefault, ...props.options };

        this.state = {
            options: options,
            success: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.success === true) {
            this.setState({
                success: true,
                options: {
                    ...this.state.options,
                    openConfirm: false
                }
            });

            setTimeout(() => {
                this.setState({ success: false });
            }, 2000);
        }
    }

    confirm = () => {
        this.setState({
            options: {
                ...this.state.options,
                openConfirm: true
            }
        });
    };

    onCancel = () => {
        this.setState({
            options: {
                ...this.state.options,
                openConfirm: false
            }
        });
    };

    render() {
        let { openConfirm } = this.state.options;
        let { options, success } = this.state;
        return (
            <span>
                {openConfirm && (
                    <SweetAlert
                        warning
                        style={{ display: 'block', marginTop: '-100px' }}
                        title={options.title}
                        onConfirm={this.props.onConfirm}
                        onCancel={this.onCancel}
                        confirmBtnBsStyle="info"
                        cancelBtnBsStyle="danger"
                        confirmBtnText={options.buttonConfirm}
                        cancelBtnText={options.buttonCancel}
                        showCancel
                    >
                        {options.message}
                    </SweetAlert>
                )}

                {success && (
                    <SweetAlert
                        success
                        style={{ display: 'block', marginTop: '-100px' }}
                        title="Listo!"
                        confirmBtnBsStyle="info"
                        onConfirm={() => this.setState({ success: false })}
                    >
                        Se ha actualizado correctamente!
                    </SweetAlert>
                )}

                <Button bsStyle="danger" onClick={this.confirm}>
                    Borrar
                </Button>
            </span>
        );
    }
}

export default DeleteButton;



// WEBPACK FOOTER //
// ./src/lib/components/DeleteButton.js